<template>
  <div>
    <!-- breadcrumb area start -->
    <div class="breadcrumb-area">
      <div class="row">
        <div class="col-md-12">
          <ol class="breadcrumb font-class">
            <li><a href="/#/home" v-on:click="sendMsg"><span class="fa fa-home"></span></a></li>
            <li><a href="/#/products" v-on:click="sendMsg">产品中心</a></li>
            <li class="active">分布式在线监测系统</li>
          </ol>
        </div>
      </div>
    </div>
    <!-- breadcrumb area end -->

    <!-- contact information start -->
    <div class="contant-information pt-20">
      <div class="row">
        <div class="center_column col-xs-12 col-sm-12">
          <div class="rte">
            <h1 style="text-align:center;font-size: 20px">分布式在线监测系统</h1>
            <hr>
            <p class="titleP">系统简介</p>
            <p>分布式在线监测系统(云平台)是一款集项目管理、设备管理、在线监测等功能于一体，致力于为用户提供简单、方便、高效的在线监测服务的监测平台，通过平台用户无论在何时何地，只要是有网的地方，通过网页输入云平台网址就可远程查看采集卡所采集的
            实时波形、远程去配置采集卡的采集参数、远程下载采集数据。</p>

            <div style="width: 80%;text-indent: 0;margin: 0 auto">
              <img src="../../../assets/product/cloud/c1.png" alt="" style="width: 49%;height: 150px">
              <img src="../../../assets/product/cloud/c2.png" alt="" style="width: 49%;height: 150px">
            </div>
            <div style="width: 80%;text-indent: 0;margin: 0 auto 50px">
              <img src="../../../assets/product/cloud/c3.png" alt="" style="width: 49%;height: 150px">
              <img src="../../../assets/product/cloud/c4.png" alt="" style="width: 49%;height: 150px">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- contact information end -->
  </div>
</template>

<script>

export default {
  name: 'contact',
  data () {
    return {
      contactData: {},
      formLeft: {
        input1: '',
        input2: '',
        input3: ''
      }
    }
  },
  mounted () {
  },
  methods: {
    render (String) {
      let temp = ''
      for (let item of String.split('\n')) {
        temp += item + '<br>'
      }
      return temp
    },
    sendMsg () {
      this.$emit('headCurrent', 0)
      window.sessionStorage.setItem('currentFirstIndex', 0)
    }
  }
}
</script>

<!-- 面包屑导航样式 -->
<style scoped>
  .breadcrumb>li+li:before {
    padding: 0 5px;
    color: #000;
    content: ">";
    font-weight: lighter;
  }

  .breadcrumb>li span{
    font-size: 16px;
  }
</style>

<!-- 内容样式 -->
<style scoped>
  .center_column{
    min-height: 400px;
  }

  .center_column p{
    font-size: 14px;
    line-height: 22px;
    margin: 0 0 9px;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    color: #000;
    position: relative;
    font-family: 宋体;
  }

  .titleP{
    padding-left: 10px!important;
    font-size: 16px;
    font-weight: bold;
    margin: 10px 0 10px!important;
    text-indent: 0!important;
  }

  .titleP:before{
    position: absolute;
    left: -5px;
    top: 0;
    content: "\2726";
    font-size: 14px;
  }

  .rte {
    background: transparent none repeat scroll 0 0;
    text-indent: 26px;
  }

  .rte img{
    width: 100%;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/cloud/cloud.vue